import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardStrikeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M10.225 4.151H3.66797V1H20.342V4.151H13.787V23H10.225V4.151Z"
        fill={color}
      />
      <path d="M2 13V11H9V13H2Z" fill={color} />
      <path d="M15 13V11H22V13H15Z" fill={color} />
    </BaseIcon>
  ),
);

BoardStrikeIcon.displayName = 'BoardStrikeIcon';
